/** Local date YYYY-MM-DD (browser local timezone) for per-day first message. */
export function todayLocalDateString(): string {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

const DAILY_ACK_PREFIX = 'warragent_daily_ro_ack_';

/** After "Looks good", skip the daily RO summary until the next calendar day (per work item). */
export function dailyRoSummaryAckKey(workItemId: string | null | undefined): string {
    return `${DAILY_ACK_PREFIX}${workItemId ?? 'none'}_${todayLocalDateString()}`;
}

export function readDailyRoSummaryDismissedToday(workItemId: string | null | undefined): boolean {
    try {
        if (typeof localStorage === 'undefined') return false;
        return localStorage.getItem(dailyRoSummaryAckKey(workItemId)) === '1';
    } catch {
        return false;
    }
}

/** Clears today's per–work-item "Looks good" flags so the RO task summary shows again (e.g. after sign-in). */
export function clearTodaysDailyRoSummaryAcks(): void {
    try {
        if (typeof localStorage === 'undefined') return;
        const suffix = `_${todayLocalDateString()}`;
        const keysToRemove: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k?.startsWith(DAILY_ACK_PREFIX) && k.endsWith(suffix)) keysToRemove.push(k);
        }
        keysToRemove.forEach(k => localStorage.removeItem(k));
    } catch {
        /* ignore quota / private mode */
    }
}
